<template>
  <a
    :class="[this.className, { 'fw-bold': this.bold }]"
    v-if="link"
    @click="handleParentClick"
    :style="[
      color ? { color: color } : { color: uiVariable.color.link },
      { textAlign: this.textAlign, marginRight: this.marginRight, cursor: 'pointer', fontSize: this.fontSize },
    ]"
  >
    <slot />
  </a>

  <span
    :class="[this.className, { 'fw-bold': this.bold }]"
    v-else
    :style="{ color: this.color, textAlign: this.textAlign, marginRight: this.marginRight, fontSize: fontSize }"
  >
    <slot /><K2Text :color="uiVariable.color.error" v-if="required">*</K2Text>
  </span>
</template>

<script>
import uiVariable from '../../config/uiVariable'

export default {
  name: 'K2Text',
  props: ['className', 'bold', 'color', 'textAlign', 'marginRight', 'link', 'onclick', 'required', 'fontSize'],
  created() {},
  data() {
    return {
      uiVariable: uiVariable,
    }
  },
  methods: {
    handleParentClick() {
      this.$emit('onclick')
    },
  },
}
</script>
